import React from "react"
import { StaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import Img from "gatsby-image/withIEPolyfill"
import TransitionLink from "gatsby-plugin-transition-link"

import Carousel from "../../atomic/molecules/Carousel"
import { TYPE, COLORS } from "../../../theme/styles/globals"
import ContentfulBlockText from "./ContentfulBlockText"

class ContentfulBlockLatestArticles extends React.Component {

  render(){

    const { title, accent, description, mode, data, transition } = this.props
    const { articles } = data

    return(
      <Container>
        <Text>
          <ContentfulBlockText 
            title={title}
            accent={accent}
            description={description}
            align={'LEFT'}
            mode={mode}
          />
        </Text>
        <Articles> 
        {articles.all.map((item, i) => (
          <Link 
            to={`/articles/${item.article.slug}`} 
            exit={transition.exit}
            entry={transition.entry}
            key={i}
          >
            <ArticleCard 
              short={item.article.short}
              slug={item.article.slug}
              thumbnail={item.article.thumbnail}
              gap={(i === 1 ? true : false)}
            />
          </Link>
        ))}
        </Articles>
      </Container>
    )

  }

}

const Container = styled.div`
  display:flex;
  justify-content:center;

  ${up('md')}{
    flex-direction:row;
  }
`

const Text = styled.div`
  display:flex;
`

const Articles = styled.div`
  display:none;
  position:relative;
  z-index:1;
  justify-content:center;
  align-items:center;
  flex-direction:column;

  ${up('md')}{
    display:flex;
  }
`

const Link = styled(TransitionLink)`
  display: flex;
 
`

const ArticleCard = ({ short, slug, thumbnail, gap }) => (
  <ArticleCardContainer gap={gap}>
    <ArticleCardTextWrap>
      <ArticleCardText>
        <span>{short}</span>
        <PlusIcon
          x={0}
          y={0}
          viewBox="0 0 15 16"
          xmlSpace="preserve"
        >
          <path d="M0 6h15v3H0z" fill={"#ffffff"} />
          <path
            transform="rotate(90 7.5 8)"
            d="M-.5 6.5h16v3h-16z"
            fill={"#ffffff"}
          />
        </PlusIcon>
      </ArticleCardText>
    </ArticleCardTextWrap>
    <ArticleCardImageWrap>
      <ArticleCardImage fluid={thumbnail.fluid} />
    </ArticleCardImageWrap>
  </ArticleCardContainer>
)

const ArticleCardTextWrap = styled.div`
  z-index:2;
  display: table-cell;
  vertical-align: middle;
  position:relative;
`

const ArticleCardText = styled.div`
  background:${COLORS.DARK_GREY_1};
  padding:10px 10px 10px 20px;
  color:white;
  width:65%;
  font-size:28px;
  font-family:${TYPE.SERIF_BOLD_FONT};
  transform:translateX(-2vh);

  span{
    width:calc(100% - 30px);
    display:inline-block;
  }

  ${up('md')}{
    padding:16px 16px 16px 24px;
    font-size:30px;
    line-height:30px;
  }
  
  ${up('xxl')}{
    padding:20px 20px 20px 30px;
    font-size:50px;
    line-height:50px;
    width:60%;
  }
`

const PlusIcon = styled.svg`
  width:20px;
  height:20px;
  position:absolute;
  right:2vh;
  top:50%;
  margin-top:-10px;
`

const ArticleCardImageWrap = styled.div`
  width:100%;
  height:100%;
  position:absolute;
  top:0px;
  left:0px;
  z-index:1;
  overflow:hidden;
`

const ArticleCardImage = styled(Img)`
  width:100%;
  height:100%;
  transition: all 0.2s ease-in-out;
  opacity: 0.8;
`

const ArticleCardContainer = styled.div`
  background:black;
  width:62vh;
  height:38vh;
  margin:1vh;
  display:table;
  position: relative;
  ${props => props.gap ? `transform:translateX(10vh);` : ``}

  &:hover{
    ${ArticleCardImage}{
      transform: scale(1.1);
      opacity: 0.5;
    }
  }
`

const query = graphql`
{
  articles: allContentfulArticle(sort: { fields: updatedAt, order: ASC }, limit: 2) {
    all:edges {
      article:node {
        slug
        short
        thumbnail{
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
      }
    }
  }
}
`

export default props => (
  <StaticQuery
    query={query}
    render={data => <ContentfulBlockLatestArticles data={data} {...props} />}
  />
)